var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.99748C0 4.02831 4.02831 0 8.99748 0C13.9645 0.00530962 17.9897 4.03053 17.995 8.99748C17.995 13.9666 13.9666 17.995 8.99748 17.995C4.02831 17.995 0 13.9666 0 8.99748ZM1.28534 8.99753C1.28534 13.2568 4.73818 16.7097 8.99747 16.7097C13.2549 16.7051 16.705 13.2549 16.7096 8.99753C16.7096 4.73824 13.2568 1.2854 8.99747 1.2854C4.73818 1.2854 1.28534 4.73824 1.28534 8.99753Z",
    fill: "#00B259"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 5.32885C13.6857 5.0883 13.2909 5.0883 13.0419 5.32885L7.06943 11.3012L4.95308 9.18488C4.7065 8.92957 4.29962 8.92253 4.04434 9.1691C3.78903 9.41568 3.78198 9.82256 4.02856 10.0778C4.03372 10.0832 4.03899 10.0885 4.04434 10.0936L6.61506 12.6643C6.86601 12.9152 7.27285 12.9152 7.5238 12.6643L13.9506 6.23755C14.1972 5.98227 14.1901 5.57543 13.9348 5.32885Z",
    fill: "#00B259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b5c469bb8bd715139a83ed7234a2e606.svg";
export { ForwardRef as ReactComponent };